<template>
  <div class="main">
    <header-bar :title="title" :platform="platform" :balance="balance"></header-bar>
    <div class="main__inner">
      <sidebar
        :data="menuData"
        :default-active="defaultActive"
        :default-openeds="defaultOpeneds"
        @on-collapse="handleCollapse"
        @on-open="handleOpen"
        @on-select="handleSelect"
      ></sidebar>
      <div class="main__content" :class="{ 'is-collapse': isCollapse }">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import * as store from 'store';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { PLATFORMS, STORE_USER_ID } from '@/global/util/constants';
import { HeaderBar, Sidebar, NyLoading } from '@/global/components';
import { flattenMenu, findMenu, generateMenu } from '@/global/router'

export default {
  components: {
    HeaderBar,
    Sidebar,
    NyLoading
  },
  props: {
    title: String,
    platform: String,
    routeData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      defaultActive: '',
      defaultOpeneds: [],
      isCollapse: false,
      userid: store.get(`${this.platform}:${STORE_USER_ID}`)
    };
  },
  computed: {
    ...mapGetters({
      balance: 'login/balance',
      menuData: 'login/menuData'
    })
  },
  watch: {
    '$route' () {
      this.getCurrentMenu()
    }
  },
  async created () {
    this.getCurrentMenu()
    const { platform, userid } = this;
    const platformMap = {
      'agency': '1',
      'ka': '2',
      'admin': '3',
      'ad-user': '4'
    }

    if (userid) {
      this['login/setUserid'](userid)
      if (platform === 'finance') {
        await this['login/getUser']({ platform, userid })
      } else {
        if (platform === 'ka') {
          this['etcd/getItem']('taihe_users').then(res => {
            this['login/setTaiheUsers'](res.data)
          })
        }
        await Promise.all([
          this['login/getUser']({ platform, userid }),
          this['login/getBalance']({
            platform,
            data: {
              account_id: userid,
              user_type: platformMap[platform]
            }
          })
        ])
      }
    }
  },
  methods: {
    ...mapMutations(['login/setUserid', 'login/setTaiheUsers']),
    ...mapActions(['login/getMenu', 'login/getUser', 'login/getBalance', 'etcd/getItem']),
    handleCollapse (isCollapse) {
      this.isCollapse = isCollapse
      this.getCurrentMenu()
    },
    getCurrentMenu () {
      const { fullPath, name } = this.$router.currentRoute
      const currentMenu = findMenu(flattenMenu(this.menuData), { fullPath, name })
      this.defaultActive = currentMenu.index
      this.defaultOpeneds = [currentMenu.index.split('-')[0]]
    },
    handleOpen (index, indexPath) {
      const { path, index: defaultActive } = this.menuData.find(item => item.index === index).children[0]
      this.$router.push({ path })
      this.defaultActive = defaultActive
    },
    handleSelect (index, indexPath) {
      this.defaultActive = index
      if (index.split('-').length === 1) {
        this.defaultOpeneds = []
      }
    }
  }
};
</script>

<style lang="scss">
@include b(main) {
  position: relative;
  padding-top: 45px;
  min-width: 1200px;

  @include e(inner) {
    width: 100%;
    height: 100%;
    background: #edf1f2;
  }

  @include e(content) {
    height: 100%;
    margin-left: 200px;
    padding: 46px 50px 46px 50px;
    transition: all 0.3s;

    @include is(collapse) {
      margin-left: 60px;
    }
  }
}
</style>
